export default function mapQrModal(buttonProps) {
  if (!buttonProps) {
    return undefined;
  }
  const {
    qrModalTitle,
    qrModalAppleStoreQrCode,
    qrModalGooglePlayQrCode,
    qrModalMicrosoftStoreQrCode,
    ...restProps
  } = buttonProps;

  const qrModal = {
    title: qrModalTitle,
    stores: [],
  };

  if (qrModalAppleStoreQrCode) {
    qrModal.stores.push({
      qr: qrModalAppleStoreQrCode,
      icon: 'apple-mono-gen',
      storeName: 'App Store',
    });
  }
  if (qrModalGooglePlayQrCode) {
    qrModal.stores.push({
      qr: qrModalGooglePlayQrCode,
      icon: 'google-play-brand',
      storeName: 'Google Play',
    });
  }
  if (qrModalMicrosoftStoreQrCode) {
    qrModal.stores.push({
      qr: qrModalMicrosoftStoreQrCode,
      icon: 'microsoft-brand',
      storeName: 'Microsoft Store',
    });
  }

  return { ...restProps, qrModal: qrModal.stores.length > 0 ? qrModal : undefined };
}
